
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"81","height":"53"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"data-name":"Vector Smart Object","width":"81","height":"53","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAAA1CAYAAAA56gd6AAABk0lEQVR4nO3bsUrDYBiF4SPWRYcKIoI4dhLq4iCik6ODOLl09YK8Aa/EwVkc1cnipC5OOigI8sqPvxACguRLG5Ked+nS5TyQpkmIuhrQA5Y7O3DSAX3gCvgEjrq9dkIB68CYnxLkYSeHTjpgowD5Dhx0e/GEMmRNZchHQwYDBgXIN2Cn1YOaqgT5asiKZchnQwYDhsBLAXKr1YOaqgSZPoezKRHMkDUFbOdD+hdysxPDpl06uRQg09l7MFsCNWXImgJ28xWNISOlS8IC5EO6ZGzvmgYrQY4NWbEM+WHIYOmOeL6hm7oHVls9qKlKkDeGrJghawo4Ab4KkCudGDbtgFEBMj1J7M+WQE39BTkHHEvyQ+7/tyfpNH/7VtJ+QryT5LsX1bvsSXqStNTWBQ00L2lN0kI6wiWdz5xApPT3Jp+dyb+No/auaSADBjNgMAMGM2AwAwYzYDADBjNgMAMGM2AwAwYzYDADBjNgMAMGM2AwAwYzYLD8xum1AStWeGXXgFUyYDAD1hBwZsBgwCJwMRVASd97o3zsDRBvggAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    